import { render, staticRenderFns } from "./TaskNotes.vue?vue&type=template&id=423a24e0&scoped=true"
import script from "./TaskNotes.vue?vue&type=script&lang=js"
export * from "./TaskNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a24e0",
  null
  
)

export default component.exports